// Imports
import styled from 'styled-components/macro';
import theme from '../../../../../shareables/theme';
import { transparentize, darken } from 'polished';


// A wrapper around the file container
export const FileWrapper = styled.div`
	display: flex;
`;


// A container for a file input
export const FileContainer = styled.div`
	font-weight: 400;
	display: grid;
	grid-auto-flow: column;
	position: relative;
	
	input {
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		opacity: 0;
		outline: none;
		position: absolute;
		z-index: 3;
		cursor: pointer;
		
		&:disabled {
			+ span {
				opacity: 0.5;
				cursor: default;
			}
		}
		
		&:hover:not(:disabled) {
			+ span {
				background-color: #eee;
				border-color: ${(props) => darken(0.1, props.theme.hasError ? theme.colors.danger : '#ddd')};
			}
		}
		
		&:focus:not(:disabled) {
			+ span {
				border-color: ${(props) => (props.theme.hasError ? theme.colors.danger : theme.colors.primary)};
				outline: none;
				box-shadow: 0 0 0 0.125em
					${(props) => transparentize(0.75, props.theme.hasError ? theme.colors.danger : theme.colors.primary)};
			}
		}
	}
`;


// The button that a user clicks to open the file selector
interface FileButtonProps {
	dragHovering?: boolean;
}

export const FileButton = styled.span<FileButtonProps>`
	height: 2.25em;
	padding: calc(0.375em - 1px) 0.75em;
	color: #4a4a4a;
	background-color: ${(props) => (props.dragHovering ? '#ccc' : '#f5f5f5')};
	border: ${(props) => props.theme.borderStyle};
	border-color: ${(props) => (props.theme.hasError ? theme.colors.danger : '#ddd')};
	border-radius: ${(props) => props.theme.borderRadius};
	${(props) => (props.dragHovering ? 'border-color: #aaa;' : '')}
	line-height: 1.5;
	white-space: nowrap;
	z-index: 2;
	
	&:not(:last-child) {
		border-bottom-right-radius: 0;
		border-top-right-radius: 0;
	}
`;


// An icon within the file button
export const FileButtonIcon = styled.span`
	margin-right: 0.5em;
`;


// The text that lists the file name(s)
export const FilesDescriptor = styled(FileButton)`
	background: #fff;
	border-left: 0;
	border-bottom-left-radius: 0;
	border-top-left-radius: 0;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	z-index: 1;
`;
